module.exports = __webpack_public_path__ + "img/mem_coupon_font2.502f2454.jpg";